<section>
  <img alt="logo da noclaf" class="up_down" src="../../../assets/icons/logo_noclaf.png">
  <h5> Carregando... </h5>
</section>